export default function Hero() {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, quiero cotizar productos de madera con Aserradero Santa Rosa.');
    window.open(`https://wa.me/56981372039?text=${message}`, '_blank');
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center pt-20">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f70ff74c880b902cd292e65dd80a8bbd.jpg"
          alt="Aserradero Santa Rosa - Madera de Calidad"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="font-serif font-bold text-5xl md:text-7xl text-white mb-4 leading-tight">
          ASERRADERO SANTA ROSA
        </h1>
        <p className="font-serif text-2xl md:text-3xl text-[#F5E6D3] mb-6">
          Más de 20 años entregando calidad
        </p>
        <p className="text-lg md:text-xl text-white font-light mb-12 max-w-3xl mx-auto leading-relaxed">
          Madera de pino radiata y especies nobles para construcción, agricultura y proyectos especiales
        </p>

        <button
          onClick={handleWhatsAppClick}
          className="inline-flex items-center gap-3 bg-[#25D366] text-white px-10 py-5 rounded-full text-lg font-bold shadow-2xl hover:scale-105 transition-transform duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-fill text-3xl"></i>
          COTIZAR POR WHATSAPP
        </button>

        <p className="text-sm text-gray-200 mt-4">
          Respuesta inmediata en horario laboral
        </p>
      </div>
    </section>
  );
}
